import { Button } from "react-bootstrap";

export default function DocumentoTitulo({ documentoDados, handleOpenModalRenomear }: iProps) {
    if (Object.values(documentoDados).length === 0) {
        return (
            <div id="documento_titulo" className="div-row">
                <h1 id="titleMain">Criar Novo Documento</h1>
            </div>
        );
    }

    return (
        <div id="documento_titulo" className="div-row">
            <h1 id="titleMain">Editar Documento: {documentoDados.nome}</h1>
            <div className="div-row">
                <Button
                    onClick={() => {
                        window.location.assign(`/documento?id=${documentoDados.codigo}`)
                    }}
                    style={{ marginLeft: "10px" }}
                    size="sm"
                >
                    Voltar
                </Button>
                {documentoDados.id_status.id_status === 1 && (
                    <Button
                        onClick={() => {
                            handleOpenModalRenomear(true);
                        }}
                        style={{ marginLeft: "10px" }}
                        size="sm"
                    >
                        Renomear
                    </Button>
                )}
            </div>
        </div>
    );
}
interface iProps {
    documentoDados: any;
    handleOpenModalRenomear: any;
}
